import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { rootReducer } from './reducers';

const persistConfig = {
  key: 'root',
  storage,
};

// Higher-order reducer to handle logout
const rootReducerWithLogout = (state, action) => {
  if (action.type === 'auth/logout') {
    // Clear persist storage
    storage.removeItem('persist:root');
    // Rebuild every slice from its initial state; returning undefined here
    // would leave the whole store empty and crash every selector.
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducerWithLogout);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export const RootState = store.getState;
export const AppDispatch = store.dispatch;

// Action creator for logout
export const logout = () => ({ type: 'auth/logout' });